import axios from "fetch-api/fetch-api";
import { IActionResponse } from "../interfaces/base-response";

export function updatePostalCodeApi(postalCode: string) {
  return axios.post<IActionResponse>("/update-postal-code-v3", { postalCode });
}
